export default class BlockerMessage {
  static typeNotSupported() {
    return {
      title: 'Your browser is not supported.',
      desktopSubTitle: 'Please update your browser.',
      mobileSubTitle: 'Please update your browser or download our apps.',
      iconClass: 'icon-not-supported',
    };
  }

  static typeErrorGeoblock(lang) {
    const message = {
      en: {
        title: 'This video is not available in your region',
        subtitle: 'You can find many other things to enjoy on Vidio!',
        cta: 'Explore Vidio',
        additionalCta: 'Error Details',
      },
      id: {
        title: 'Konten ini nggak tersedia di negaramu',
        subtitle:
          'Masih banyak konten menarik lainnya yang bisa kamu nikmatin di Vidio, lho!',
        cta: 'Jelajahi Vidio',
        additionalCta: 'Detail Error',
      },
    };
    return message[lang];
  }

  static typeErrorNetworkIssue(lang) {
    const message = {
      en: {
        title: 'Network error',
        subtitle:
          "There's a problem connecting to Vidio. Please try again later. ",
        cta: 'Retry',
        additionalCta: 'Error Details',
      },
      id: {
        title: 'Masalah pada jaringan',
        subtitle: 'Ada kendala saat terhubung ke Vidio. Coba lagi nanti, ya.',
        cta: 'Coba Lagi',
        additionalCta: 'Detail Error',
      },
    };
    return message[lang];
  }

  static typeErrorMediaIssue(lang) {
    const message = {
      en: {
        title: 'An error occurred while processing the media',
        subtitle: 'Please try again with another device',
        cta: 'Report Problem',
        additionalCta: 'Error Details',
      },
      id: {
        title: 'Terjadi kesalahan saat memproses media',
        subtitle: 'Silakan coba lagi dengan perangkat lain',
        cta: 'Laporkan Masalah',
        additionalCta: 'Detail Error',
      },
    };
    return message[lang];
  }

  static typeErrorDRMIssue(lang) {
    const message = {
      id: {
        title: 'Perangkatmu nggak mendukung DRM',
        subtitle:
          'Coba lagi dengan perangkat yang mendukung atau cari hiburan lain di Vidio, yuk.',
        cta: 'Jelajahi Vidio',
        additionalCta: 'Detail Error',
      },
      en: {
        title: 'Your device does not support DRM',
        subtitle:
          'Please try again with a compatible device or browse around for more entertainment.',
        cta: 'Explore Vidio',
        additionalCta: 'Error Details',
      },
    };

    return message[lang];
  }

  static typeErrorGeneralIssue(lang) {
    const message = {
      id: {
        title: 'Terjadi gangguan nih',
        subtitle: 'Tunggu selagi kami mengatasinya dan coba lagi nanti, ya!',
        cta: 'Coba Lagi',
        additionalCta: 'Laporkan Masalah',
        labelAdditionalCta: 'Masih bermasalah?',
      },
      en: {
        title: 'Oops, something went wrong',
        subtitle: 'Sit tight while we get things fixed and try again later.',
        cta: 'Retry',
        additionalCta: 'Report Problem',
        labelAdditionalCta: 'Still have problems?',
      },
    };

    return message[lang];
  }

  static typeErrorFetching(lang) {
    const message = {
      id: {
        title: 'Terjadi gangguan nih',
        subtitle: 'Tunggu selagi kami mengatasinya dan coba lagi nanti, ya!',
        cta: 'Coba Lagi',
        additionalCta: 'Laporkan Masalah',
        labelAdditionalCta: 'Masih bermasalah?',
      },
      en: {
        title: 'Oops, something went wrong',
        subtitle: 'Sit tight while we get things fixed and try again later.',
        cta: 'Retry',
        additionalCta: 'Report Problem',
        labelAdditionalCta: 'Still have problems?',
      },
    };

    return message[lang];
  }

  static typeMediaNotSupported(lang) {
    const message = {
      id: {
        title: 'Terdapat kendala pada perangkatmu',
        subtitle: 'Silakan coba lagi dengan perangkat lain.',
        cta: 'Laporkan Masalah',
        additionalCta: 'Detail Error',
      },
      en: {
        title: 'Problem with your device',
        subtitle: 'Please try again with another device.',
        cta: 'Report Problem',
        additionalCta: 'Error Details',
      },
    };

    return message[lang];
  }
}
